import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Language } from '../hooks/use-language';
import appI18n from './index';

// 扩展翻译函数的类型
type TFunction = (key: string | string[], options?: Record<string, any>) => string;

/**
 * 应用级别的 useTranslation hook
 * 使用独立的 appI18n 实例
 */
export const useAppTranslation = () => {
  const { t: originalT, ...rest } = useTranslation<Language>(undefined, { i18n: appI18n });

  // 包装 t 函数，确保返回类型为 string
  const t: TFunction = useCallback(
    (key, options = {}) => {
      return originalT(key as any, options);
    },
    [originalT]
  );

  return useMemo(() => ({ t, ...rest }), [t, rest]);
};

/**
 * 切换应用语言
 */
export const changeAppLanguage = (lang: string) => {
  return appI18n.changeLanguage(lang);
};
